import { createRouter, createWebHistory, Router, RouteRecordRaw } from 'vue-router'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import DarkLayout from '@/layouts/DarkLayout.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: DarkLayout,
        children: [
            {
                path: '',
                name: 'home.index',
                meta: { layout: 'fixed' },
                component: () => import('@/views/home/Index.vue'),
            },
            {
                path: 'readme',
                name: 'home.readme',
                meta: { layout: 'fixed' },
                component: () => import('@/views/home/Readme.vue'),
            },
            {
                path: 'system',
                name: 'home.system',
                meta: { layout: 'fixed', flex: 'v-center' },
                component: () => import('@/views/home/System.vue'),
            },
        ],
    },
    {
        path: '/exam',
        component: DarkLayout,
        children: [
            {
                path: 'readme',
                name: 'exam.readme',
                component: () => import('../views/exam/Readme.vue'),
            },
        ],
    },
    {
        path: '/my',
        component: DarkLayout,
        children: [
            {
                path: 'collection',
                name: 'my.collection',
                meta: { position: 'side-long', name: 'my:collection' },
                component: () => import('../views/my/Collection.vue'),
            },
            {
                path: 'wrong',
                name: 'my.wrong',
                meta: { name: 'my:wrong' },
                component: () => import('../views/my/Wrong.vue'),
            },
            {
                path: 'data',
                name: 'my.data',
                meta: { name: 'my:data' },
                component: () => import('../views/my/Data.vue'),
            },
            {
                path: 'report',
                name: 'my.report',
                meta: { name: 'my:report', topClass: 'report' },
                component: () => import('../views/my/Report.vue'),
            },
            {
                path: 'password',
                name: 'my.password',
                meta: { position: 'side', name: 'my:password', layout: 'fixed' },
                component: () => import('../views/my/Password.vue'),
            },
            {
                path: 'feedback',
                name: 'my.feedback',
                meta: { position: 'side-long', name: 'my:feedback' },
                component: () => import('../views/my/Feedback.vue'),
            },
            {
                path: 'feedback-detail',
                name: 'my.feedback-detail',
                meta: { position: 'side-long', name: 'my:feedback' },
                component: () => import('../views/my/FeedbackDetail.vue'),
            },
        ],
    },
    {
        path: '/special',
        component: DarkLayout,
        children: [
            {
                path: '',
                name: 'special.index',
                meta: { position: 'wide', name: 'model', layout: 'fixed' },
                component: () => import('../views/special/Index.vue'),
            },
            {
                path: 'answer',
                name: 'special.answer',
                meta: { position: 'side-long', name: 'special:answer' },
                component: () => import('../views/special/Answer.vue'),
            },
            {
                path: 'record',
                name: 'special.record',
                meta: { name: 'special:record', layout: 'fixed' },
                component: () => import('../views/special/Record.vue'),
            },
            {
                path: 'success',
                name: 'special.success',
                meta: { position: 'side', name: 'special:success', layout: 'fixed' },
                component: () => import('../views/special/Success.vue'),
            },
        ],
    },
    {
        path: '/docs',
        component: DarkLayout,
        children: [
            {
                path: '',
                name: 'docs.index',
                meta: { position: 'wide', name: 'docs', layout: 'fixed' },
                component: () => import('../views/docs/Index.vue'),
            },
            {
                path: 'detail/:id',
                name: 'docs.detail',
                meta: { position: 'wide', name: 'detail', layout: 'fixed' },
                component: () => import('../views/docs/Detail.vue'),
            },
        ],
    },
    {
        path: '/login',
        component: EmptyLayout,
        children: [
            {
                path: '',
                name: 'user.login',
                component: () => import('../views/user/Login.vue'),
            },
            {
                path: 'confirm',
                name: 'user.confirm',
                component: () => import('../views/user/Confirm.vue'),
            },
        ],
    },
    {
        path: '/suit',
        component: DarkLayout,
        children: [
            {
                path: '',
                name: 'suit.index',
                meta: { position: 'side', name: 'suit', layout: 'fixed' },
                component: () => import('../views/suit/Index.vue'),
            },
            {
                path: 'record',
                name: 'suit.record',
                meta: { position: 'side', name: 'suit:record', layout: 'fixed' },
                component: () => import('../views/suit/Record.vue'),
            },
            {
                path: 'result',
                name: 'suit.result',
                meta: { layout: 'fixed' },
                component: () => import('../views/suit/Result.vue'),
            },
            {
                path: 'rank',
                name: 'suit.rank',
                component: () => import('../views/suit/Rank.vue'),
            },
        ],
    },
    {
        path: '/suit',
        component: EmptyLayout,
        children: [
            {
                path: 'test',
                name: 'suit.test',
                component: () => import('../views/suit/Test.vue'),
            },
        ],
    },
]

const router: Router = createRouter({
    history: createWebHistory('/pps/'),
    routes,
})

export default router
